import { BuildingDTO } from "./building";
import { FileLog } from "./file";


export enum ElevatorPresentStatus {
    HAS_ELEVATOR = 'Lift aanwezig, in dienst',
    HAS_ELEVATOR_OUT_SERVICE = 'Lift aanwezig, uit dienst',
    NO_ELEVATOR = 'Geen lift aanwezig',
    UNKNOWN = 'Onbekend'
  }

export type CommonInstallationsInfoDTO = {
    id: number;
    building: BuildingDTO;
    buildingId: string;
    elevatorInspectionCertificateFileLogId: number;
    elevatorRiskAnalysisFileLogId: number;
    elevatorMaintenanceContractFileLogId: number;
    elevatorInspectionCertificateFileLog: FileLog;
    elevatorRiskAnalysisFileLog: FileLog;
    elevatorMaintenanceContractFileLog: FileLog;
    elevatorContractTerminationDate: Date;
    lastElevatorMaintenanceDate: Date;
    nextElevatorMaintenanceDate: Date;
    elevatorRemarks: string;
    elevatorYearOfManufacture: number;
    elevatorBrand: string;
    elevatorPresentStatus: ElevatorPresentStatus;
}
